import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ProviderSurveyEmailLookup } from './ProviderSurveyEmailLookup';
import { ProviderSurveyForm } from './ProviderSurveyForm';

export const ProviderSurveyWrapper: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) {
    return (
      <ProviderSurveyEmailLookup
        onFoundSurveyId={(id) => {
          navigate(`/endorsement/provider-survey/${id}`);
        }}
      />
    );
  }

  return <ProviderSurveyForm id={id} />;
};

export default ProviderSurveyWrapper;
